import React from 'react';
import PropTypes from 'prop-types';

import { FEATURE_FLAGS } from 'config';

const Feature = ({ children, enabled }) => (enabled ? <>{children}</> : null);

Feature.propTypes = {
  children: PropTypes.node,
  enabled: PropTypes.bool,
};

Feature.defaultProps = {
  children: null,
  enabled: !FEATURE_FLAGS.HIDE_DUMMY_ITEMS,
};

export default Feature;
